export enum InventoryStatus {
  Ideal,
  Restrictions,
  Never,
  OutOfStock,
}
